/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable no-tabs */
import React, { Suspense, useEffect, useState } from 'react';
import Amplify from 'aws-amplify';
import { BrowserRouter as Router, Route, Switch, Redirect, useLocation, useHistory } from 'react-router-dom';
import { Modal, Button } from 'antd';

import Admin from './Admin';
import Loader from './AppLoader';
import Logout from './Component/Auth/Logout';
import Home from './Component/Home';

import Session from './Service/Session';
import LoanCalculator from './LoanCalculator';
import EmbedCalculator from './LoanCalculator/embed';

Session.trackVisitReferral();

const AppConfig = window.AppConfig;
const USER_TYPE = window.AppConfig.USER_TYPES;
Amplify.configure({ Auth: AppConfig.COGNITO });

function UrlCleaner() {
	const { pathname, search, hash } = useLocation();

	useEffect(() => {
		if (pathname.endsWith('.')) {
			// Remove trailing period(s) while preserving query/hash
			const cleanedPath = pathname.replace(/\.+$/, '');
			const fullPath = cleanedPath + search + hash;

			// Reload the page with the cleaned URL
			window.location.href = fullPath;
		}
	}, [pathname, search, hash]);

	return null; // No rendering needed
}

export default function App({ history }) {
	const currentUser = Session.get('CURRENT_USER_INFO');
	const [deferredPrompt, setDeferredPrompt] = useState(null);

	const userType = currentUser !== null ? currentUser.attributes['custom:user_type'] : null;

	useEffect(() => {
		window.addEventListener('beforeinstallprompt', e => {
			// Prevent the default mini-infobar from appearing on mobile
			e.preventDefault();
			// Store the event so it can be triggered later
			setDeferredPrompt(e);
		});
	}, []);

	const handleInstallClick = () => {
		if (deferredPrompt) {
			// Show the install prompt
			deferredPrompt.prompt();
			// Wait for the user to respond to the prompt
			deferredPrompt.userChoice.then(choiceResult => {
				if (choiceResult.outcome === 'accepted') {
					console.log('User accepted the install prompt');
				} else {
					console.log('User dismissed the install prompt');
				}
				setDeferredPrompt(null);
			});
		}
	};

	return (
		<Suspense fallback={<Loader />}>
			<Router history={history}>
				<Modal
					visible={!!deferredPrompt}
					onCancel={() => setDeferredPrompt(null)}
					footer={null}
					centered
					width={500}
					style={{ top: 20 }}
					destroyOnClose
					maskClosable={false}>
					<div
						style={{
							textAlign: 'center'
						}}>
						<img src="/images/LendAmi-Philippines.svg" alt="Logo" style={{ marginLeft: '-82px' }} />
						<h1
							style={{
								fontSize: '20px',
								fontWeight: 'bolder',
								color: '#276d8c'
							}}>
							Add LendAmi Web App to Your Home Screen?
						</h1>
						<p style={{ color: 'gray', fontWeight: '200' }}>
							Add this app on your home screen for quick and easy access when you're on the go?
						</p>

						<Button size="medium" type="primary" onClick={handleInstallClick}>
							ADD TO HOME SCREEN
						</Button>
					</div>
				</Modal>
				<UrlCleaner />
				<Switch>
					<Route component={Home} exact path="/" />
					<Route component={Home} path="/loan/:id" />
					<Route component={Home} path="/admin/loans/:id" />
					<Route component={Home} path="/amortization-table/:id" />
					<Route component={LoanCalculator} path="/loan-calculator" />
					<Route component={EmbedCalculator} path="/loan-calculator-embed" />
					<Route component={Home} path="/modify-loan/:id" />
					<Route component={Home} path="/signup" />
					<Route component={Home} path="/signin" />
					<Route component={Home} path="/profile" />
					<Route component={Home} path="/reset-password" />
					<Route component={Logout} path="/logout" strict />
					{!currentUser ? (
						<Redirect to="/" />
					) : (
						<Route component={userType !== USER_TYPE.NORMAL_USER ? Admin : Home} path="/admin" />
					)}
					<Route component={Home} path="*" />
				</Switch>
			</Router>
		</Suspense>
	);
}
